<template>
  <div>
    <div class="d-flex button-group justify-content-end">
      <b-btn variant="outline-success" @click="saveProduct">
        {{ $t('buttons.common.save')}}
      </b-btn>
    </div>
    <div class="filter-form">
      <b-row>
        <b-col>
          <label>{{$t('labels.common.group')}}</label>
          <multiselect v-model="productData.group" :max-height="200"
                       placeholder="Choose group" label="name" track-by="name"
                       :options="optionsData.group"
                       :close-on-select="true" :class="{ required: !productData.group}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.wood')}}</label>
          <multiselect v-model="productData.tree" :max-height="200"
                       placeholder="Choose wood" label="name" track-by="name"
                       :options="optionsData.tree"
                       :close-on-select="true" :class="{ required: !productData.tree}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.unit_weight')}}</label>
          <input v-model="productData.unit_weight"
                 class="form-control"
                 placeholder="Choose unit weight" :class="{ required: !productData.unit_weight}">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.diameter')}}</label>
          <multiselect v-model="productData.diameter" :max-height="200"
                       placeholder="Choose diameter" label="name" track-by="name"
                       :options="optionsData.diameter"
                       :close-on-select="true" :class="{ required: !productData.diameter}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.bag_logo')}}</label>
          <multiselect v-model="productData.bag_logo" :max-height="200"
                       placeholder="Choose bag logo" label="name" track-by="name"
                       :options="optionsData.bag_logo"
                       :close-on-select="true" :class="{ required: !productData.bag_logo}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.quantity')}}</label>
          <input v-model="productData.pieces"
                 class="form-control"
                 placeholder="Choose number of pieces"
                 :class="{ required: !productData.pieces}">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.quality')}}</label>
          <multiselect v-model="productData.quality" :max-height="200"
                       placeholder="Choose quality" label="name" track-by="name"
                       :options="optionsData.quality"
                       :close-on-select="true" :class="{ required: !productData.quality}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.wood_certificate')}}</label>
          <multiselect v-model="productData.wood_certificate" :max-height="200"
                       placeholder="Choose certificate" label="name" track-by="name"
                       :options="optionsData.wood_certificate"
                       :close-on-select="true" :class="{ required: !productData.wood_certificate}"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.pallet_size')}}</label>
          <multiselect v-model="productData.pallet_size" :max-height="200"
                       placeholder="Choose pallet size" label="name" track-by="name"
                       :options="optionsData.pallet_size"
                       :close-on-select="true" :class="{ required: !productData.pallet_size}"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{productData.name}}</label>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import {handlerResponse} from '@/helpers/commonHelpers';
  import {notificationsRenderer} from '@/helpers/renderHelpers';

  export default {
    components: {
      Multiselect,
    },
    data() {
      return {
        optionsData: {
          group: [],
          tree: [],
          diameter: [],
          bag_logo: [],
          wood_certificate: [],
          pallet_size: [],
          quality: []
        },
        productData: {
          name: '',
          wood_certificate: null,
          quality: null,
          tree: null,
          group: null,
          unit_weight: null,
          diameter: null,
          bag_logo: null,
          pieces: null,
          pallet_size: null,
          package_type: null
        }
      }
    },
    methods: {
      saveProduct() {
        const savedData = {
          group: this.productData.group && this.productData.group.id,
          tree: this.productData.tree && this.productData.tree.id,
          unit_weight: this.productData.unit_weight,
          diameter: this.productData.diameter && this.productData.diameter.id,
          bag_logo: this.productData.bag_logo && this.productData.bag_logo.id,
          pieces: +this.productData.pieces,
          quality: this.productData.quality && this.productData.quality.id,
          wood_certificate: this.productData.wood_certificate && this.productData.wood_certificate.id,
          pallet_size: this.productData.pallet_size && this.productData.pallet_size.id,
          package_type: this.productData.package_type && this.productData.package_type.id
        };
        this.$http.post(`woodware/create_or_get_exists_product/`, savedData).then(handlerResponse).then((response) => {
          this.$router.push({path: `/product/${response.id}`});
        }).catch((error) => {
          notificationsRenderer(error.data, 'error');
        });
      },
      loadProductData() {
        const params = {for_vue: true};
        this.$http.get(`woodware/products/${this.param}/`, {params}).then(handlerResponse).then((response) => {
          this.productData = {...this.productData, ...response};
        });
      },
      fetchInitializeData() {
        this.$http.get(`woodware/list/data_for_product_selects/`).then(handlerResponse).then((response) => {
          this.optionsData = {...response};
          if (!this.isNewProduct) {
            this.loadProductData();
          }
        });
      }
    },
    computed: {
      param() {
        return this.$route.params.id;
      },
      isNewProduct() {
        return this.param === 'new';
      },
    },
    created() {
      this.fetchInitializeData();
    },
    beforeRouteUpdate(to, from, next) {
      next();
      this.fetchInitializeData();
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/modules/general/products/Product.vue